import { HYDRATE } from 'next-redux-wrapper';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../GlobalRedux/store';

export interface User {
  name: string;
  email: string;
  photo: string;
}

export interface AuthState {
  isAuthenticated: boolean;
  loading: boolean;
  user: User | null;
  route: string;
}

const initialState: AuthState = {
  isAuthenticated: false,
  loading: false,
  user: null,
  route: '/',
};

const AUTH_STATE_KEY = 'authState';

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginRequest: state => {
      state.loading = true;
    },
    setAuthState: (state, action) => {
      state.loading = false;
      state.isAuthenticated = action.payload;
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(
          AUTH_STATE_KEY,
          JSON.stringify(action.payload),
        );
      }
    },
    loginSuccess: (state, action: PayloadAction<User>) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.loading = false;
      state.route = '/';
    },
    loginFailure: state => {
      state.loading = false;
    },

    logoutSuccess: state => {
      state.isAuthenticated = false;
      state.user = null;
      state.loading = false;
    },
    logoutFailure: state => {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      return {...state, ...action}
    })
  }
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  logoutSuccess,
  logoutFailure,
  setAuthState,
} = authSlice.actions;

export const selectAuthState = (state: RootState) => state.auth.isAuthenticated;

export default authSlice.reducer;
